import styled from "@emotion/styled";

export const Right = styled.div`
    width: 100%;
    text-align: right;
`;

export const Icon = styled.img`
    width: 40px;
    height: 40px;
`;
